// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__rcUsL","namePhoneContainer":"style_namePhoneContainer__7aJ7S"};